export default __webpack_public_path__ + "v1.18.25/static/media/LibreDataSharecode_Japanese.30f658c9.svg";